import Step from "./step";

export default class WizardStepsForm {
  static prepare(container) {
    return new WizardStepsForm(container);
  }

  constructor($container) {
    if (!$container)
      return;

    this.$container = $container;
    this.steps = {};
    this.$allSteps = this.$container.querySelectorAll('.step');
    this.$allSteps.forEach((el) => this.forEachStep(el));
    this.updateStepsRequirements();
  }

  addEventListener(event, func) {
    for (let [_, wizardStepForm] of Object.entries(this.steps))
      wizardStepForm.addEventListener(event, func);

    return this;
  }

  start() {
    let _stepToStart = this.stepToStart;

    if (_stepToStart.classList.contains('disabled'))
      _stepToStart = this.firstEnabledStep();

    this.selectStep(_stepToStart);

    return this;
  }

  stepBack() {
    let index = this.findIndexSelectedStep();
    if (index === 0)
      return;

    this.selectStep(this.steps[Object.keys(this.steps)[index - 1]].$step);
  }

  stepForward() {
    let index = this.findIndexSelectedStep();
    if (index === Object.keys(this.steps).length - 1)
      return;

    this.selectStep(this.steps[Object.keys(this.steps)[index + 1]].$step);
  }

  findIndexSelectedStep() {
    return Object.keys(this.steps).indexOf(this.currentStepId);
  }

  forEachStep(stepEl) {
    let wizardStepForm = new Step(stepEl, this.$container);
    this.steps[stepEl.dataset.step] = wizardStepForm;
    stepEl.addEventListener('click', () => {
      if (!stepEl.classList.contains('disabled'))
        this.onClickStepSelect(stepEl);
    });
  }

  updateStepsRequirements() {
    for (let [_, wizardStepForm] of Object.entries(this.steps)) {
      let requiredStep = this.steps[wizardStepForm.dataRequiredStep];

      if (!!requiredStep)
        wizardStepForm.requiredStep = requiredStep;

      wizardStepForm.update();
    };
  }

  onClickStepSelect(stepEl) {
    if (stepEl.dataset.step === this.currentStepId)
      return;

    this.selectStep(stepEl);
    $(stepEl).trigger('select');
  }

  selectStep(stepEl) {
    if (typeof stepEl === "string")
      stepEl = this.$container.querySelector(`[data-step="${stepEl}"]`);

    this.currentStepId = stepEl.dataset.step;

    if (!this.currentStepId)
      return;

    this.$container.querySelectorAll('.step').forEach((el) => { el.classList.remove('selected') });
    stepEl.classList.add('selected');
    window.location.hash = this.currentStepId;
    stepEl.dataset.select = (stepEl.dataset.select || 0) + 1;
    $(stepEl).trigger('select');

    requestAnimationFrame(() => {
      this.fadeOutAllSteps(() => {
        requestAnimationFrame(() => { this.showUpSelectedStep(this.currentStepId) });
      })
    });
  }

  fadeOutAllSteps(afterAnimation) {
    let stepsContent = document.querySelectorAll('[data-step-content]');
    stepsContent.forEach((el) => el.classList.replace('show', 'out') );

    setTimeout(() => {
      stepsContent.forEach((el) => el.classList.toggle('hidden', true) );
      afterAnimation();
    }, 150);
  }

  showUpSelectedStep(currentStepId) {
    let stepBoxEl = document.querySelector(`[data-step-content="${currentStepId}"]`);

    if (!stepBoxEl)
      return;

      stepBoxEl.classList.remove('out', 'hidden');
      stepBoxEl.classList.toggle('show', true);
  }

  stepOverURL() {
    let hash = window.location.hash;
    return hash.replace(/^\#/, '') // remove fragment code from start
  }

  step(dataStep, setFunction) {
    setFunction(this.getStep(dataStep));

    return this;
  }

  getStep(dataStep) {
    let step = this.steps[dataStep];

    if (!step) {
      throw('wrong dataStep name');
    }

    return step;
  }

  firstEnabledStep() {
    return this.$container.querySelector('.step:not(.disabled)');
  }

  get stepToStart() {
    let stepData = this.stepOverURL(),
      fromURL = this.$container.querySelector(`.step[data-step="${stepData}"]`);

    if (!stepData || stepData === '' || !fromURL)
      return this.$container.querySelector('.step.selected');

    return this.$container.querySelector(`.step[data-step="${stepData}"]`);
  }
}